import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import Header from '@components/Header/Header';
import Footer from '@components/Footer/Footer';
import HomePage from '@components/pages/HomePage';
import ProductsPage from '@components/pages/ProductsPage';
import GalleryPage from '@components/pages/GalleryPage';
import AboutPage from '@components/pages/AboutPage';
import ContactPage from '@components/pages/ContactPage';
import { 
  TilesPage, 
  CPFittingsPage, 
  BathFittingsPage, 
  BathAccessoriesPage, 
  KitchenFittingsPage, 
  SanitaryWarePage, 
  GranitePage 
} from '@components/Gallery';
import { ProductProvider } from '@context/ProductContext';

const App = () => {
  return (
    <HelmetProvider>
      <ProductProvider>
        <Router>
          <div>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
                          <Route path="/gallery/tiles" element={<TilesPage />} />
            <Route path="/gallery/cp-fittings" element={<CPFittingsPage />} />
            <Route path="/gallery/bath-fittings" element={<BathFittingsPage />} />
            <Route path="/gallery/bath-accessories" element={<BathAccessoriesPage />} />
            <Route path="/gallery/kitchen-fittings" element={<KitchenFittingsPage />} />
            <Route path="/gallery/sanitary-ware" element={<SanitaryWarePage />} />
            <Route path="/gallery/granite" element={<GranitePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          </div>
        </Router>
      </ProductProvider>
      <Analytics />
    </HelmetProvider>
  );
};

export default App;